import { render, staticRenderFns } from "./DownloadFAQ.vue?vue&type=template&id=7edec868&scoped=true&"
import script from "./DownloadFAQ.vue?vue&type=script&lang=js&"
export * from "./DownloadFAQ.vue?vue&type=script&lang=js&"
import style0 from "./DownloadFAQ.vue?vue&type=style&index=0&id=7edec868&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7edec868",
  null
  
)

export default component.exports